import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d028b608&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/dennis/Projects/klussenmetkees/wp-content/themes/klussen-met-kees/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VParallax } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VContent,VFlex,VFooter,VIcon,VLayout,VList,VListTile,VListTileAction,VListTileContent,VNavigationDrawer,VParallax,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})


/* vuetify-loader */
import installDirectives from "!/Users/dennis/Projects/klussenmetkees/wp-content/themes/klussen-met-kees/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Scroll } from 'vuetify/lib/directives'
installDirectives(component, {Scroll})
